import { normalisePath } from '@/shared/utils/urls'

type HttpMethod = 'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH' | 'HEAD'
type AllowedPath = string | string[]

/**
 * Create a new API client for the given target system.
 *
 */
export function createClient(baseUrl: URL) {
  return {
    sendGet: (path: AllowedPath) => sendRequest('GET', new URL(normalisePath(path), baseUrl)),
    sendPost: (path: AllowedPath, body?: unknown) => sendRequest('POST', new URL(normalisePath(path), baseUrl), body),
    sendPut: (path: AllowedPath, body?: unknown) => sendRequest('PUT', new URL(normalisePath(path), baseUrl), body),
    sendPatch: (path: AllowedPath, body?: unknown) => sendRequest('PATCH', new URL(normalisePath(path), baseUrl), body),
    sendDelete: (path: AllowedPath) => sendRequest('DELETE', new URL(normalisePath(path), baseUrl)),
    buildUrl: (path: AllowedPath) => new URL(normalisePath(path), baseUrl)
  }
}

/**
 * Performs the actual sending of the request using the browser's fetch() function.
 * All requests are treated as JSON request bodies, and responses are set to only accept JSON.
 *
 */
async function sendRequest(method: HttpMethod, url: URL, body?: unknown, init?: RequestInit) {
  // Ensure we always have an object.
  init = init || { }

  // Always send the necessary credentials.
  init.credentials = "include"

  // Override the method.
  init.method = method.toUpperCase()

  // Always populate headers.
  init.headers = new Headers(init.headers)

  // Ensure we accept JSON as a response.
  init.headers.set('accept', 'application/json')

  if (body !== undefined) {
    init.headers.set('content-type', 'application/json')
    init.body = JSON.stringify(body)
  }

  return fetch(url.toString(), init)
}
